import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsModule, AmountPipe } from '@bayclubs/utils';

//application components
import { CalendarService } from './services/calendar.service';
import { FeeAmountPipe } from './pipes/fee-amount.pipe';

@NgModule({
    imports: [CommonModule, UtilsModule],
    providers: [AmountPipe],
    declarations: [FeeAmountPipe],
    exports: [FeeAmountPipe]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [CalendarService]
        };
    }
}
